export const fonts = { heading: "Poppins", body: "Poppins" };
